import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDc5KJJu8s4FP7ZrN2q26tgNKB1-EYMaVo",
  authDomain: "hooks-courier.firebaseapp.com",
  projectId: "hooks-courier",
  storageBucket: "hooks-courier.firebasestorage.app",
  messagingSenderId: "817120149106",
  appId: "1:817120149106:web:70cb17e0930b85b9cf8ceb",
};

const app = initializeApp(firebaseConfig);

let messaging = null;

(async () => {
  const supported = await isSupported();

  console.log("Firebase Messaging Supported:", supported);

  if (supported) {
    messaging = getMessaging(app);
  } else {
    console.log("Firebase Messaging NOT supported on this browser.");
  }
})();

export { messaging };